// $FlowFixMe[untyped-import]
import { createAction } from 'redux-act';
// Helpers
const assignMeta = method => (url, ...extra) => ({
  http: true,
  method: method ? method.toUpperCase() : undefined,
  url,
  // data are only provided if there is options as well
  data: extra.length >= 2 ? extra[0] : undefined
});

/**
 * @description Action to customize fetch method which will called by fetcher middleware
 * @example
 * ```javascript
 * dispatch(
 *   GET('/myresource', {
 *     timeout: 3000,
 *     on200: (response) => {
 *       ...
 *       return response
 *     },
 *     on2XX: (response) => {
 *       ...
 *       return response
 *     },
 *   })
 * );
 * ```
 */

export const FETCH = createAction('HTTP FETCH', (fetch, options) => ({
  fetch,
  options
}), assignMeta('FETCH'));

/**
 * @description Action to call the get method on fetcher middleware
 * @example
 * ```javascript
 * dispatch(
 *   GET('/myresource', {
 *     timeout: 3000,
 *     on200: (response) => {
 *       ...
 *       return response
 *     },
 *     on2XX: (response) => {
 *       ...
 *       return response
 *     },
 *   })
 * );
 * ```
 */

export const GET = createAction('HTTP GET', (url, options) => ({
  options,
  fetch: fetcher => fetcher.get(url, options)
}), assignMeta('GET'));

/**
 * @description Action to call the head method on fetcher middleware
 * @example
 * ```javascript
 * dispatch(
 *   HEAD('/myresource', {
 *     timeout: 3000,
 *     on200: (response) => {
 *       ...
 *       return response
 *     },
 *     on2XX: (response) => {
 *       ...
 *       return response
 *     },
 *   })
 * );
 * ```
 */

export const HEAD = createAction('HTTP HEAD', (url, options) => ({
  options,
  fetch: fetcher => fetcher.head(url, options)
}), assignMeta('HEAD'));

/**
 * @description Action to call the put method on fetcher middleware
 * @example
 * ```javascript
 * dispatch(
 *   PUT('/myresource', data, {
 *     timeout: 3000,
 *     on200: (response) => {
 *       ...
 *       return response
 *     },
 *     on2XX: (response) => {
 *       ...
 *       return response
 *     },
 *   })
 * );
 * ```
 */

export const PUT = createAction('HTTP PUT', (url, body, options) => ({
  options,
  fetch: fetcher => fetcher.put(url, body, options)
}), assignMeta('PUT'));

/**
 * @description Action to call the patch method on fetcher middleware
 * @example
 * ```javascript
 * dispatch(
 *   PATCH('/myresource', data, {
 *     timeout: 3000,
 *     on202: (response) => {
 *       ...
 *       return response
 *     },
 *     on2XX: (response) => {
 *       ...
 *       return response
 *     },
 *   })
 * );
 * ```
 */

export const PATCH = createAction('HTTP PATCH', (url, body, options) => ({
  options,
  fetch: fetcher => fetcher.patch(url, body, options)
}), assignMeta('PATCH'));

/**
 * @description Action to call the delete method on fetcher middleware
 * @example
 * ```javascript
 * dispatch(
 *   DELETE('/myresource', undefined, {
 *     timeout: 3000,
 *     on204: (response) => {
 *       ...
 *       return response
 *     },
 *     on2XX: (response) => {
 *       ...
 *       return response
 *     },
 *   })
 * );
 * ```
 */

export const DELETE = createAction('HTTP DELETE', (url, body, options) => ({
  fetch: fetcher => fetcher.delete(url, body, options),
  options
}), assignMeta('DELETE'));

/**
 * @description Action to call the post method on fetcher middleware
 * @example
 * ```javascript
 * dispatch(
 *   POST('/myresource', data, {
 *     timeout: 3000,
 *     on201: (response) => {
 *       ...
 *       return response
 *     },
 *     on2XX: (response) => {
 *       ...
 *       return response
 *     },
 *   })
 * );
 * ```
 */

export const POST = createAction('HTTP POST', (url, body, options) => ({
  options,
  fetch: fetcher => fetcher.post(url, body, options)
}), assignMeta('POST'));